import { vehicleLead } from './vehicleLead'

export const leadApi = {
  vehicleLead,
}
